import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './defaultScreens/page-not-found/page-not-found.component';
import { SigninComponent } from './login/signin/signin.component';

const routes: Routes = [
  // Public routes (no sidebar, no guard)
  { path: 'signin', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'forgot-password', loadChildren: () => import('./forgot-passowrd/forgot-passowrd.module').then(m => m.ForgotPassowrdModule) },
  { path: 'reset-password', loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule) },
  { path: 'privacy-policy', loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule) },
  { path: 'contact-us', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule) },


  // Protected routes
  { path: '', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },

  // This allows URLs like /subadmin/dashboard, /subadmin/user-management/..., etc.
  { path: 'subadmin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },

  // Fallbacks
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
